import { render, staticRenderFns } from "./shanxiTrainingSupervisionSecond.vue?vue&type=template&id=773034ec"
import script from "./shanxiTrainingSupervisionSecond.vue?vue&type=script&lang=js"
export * from "./shanxiTrainingSupervisionSecond.vue?vue&type=script&lang=js"
import style0 from "./shanxiTrainingSupervisionSecond.vue?vue&type=style&index=0&id=773034ec&prod&lang=less&scope=true"
import style1 from "./shanxiTrainingSupervisionSecond.vue?vue&type=style&index=1&id=773034ec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports